/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Flex, Image } from '@chakra-ui/react';
import { format } from 'date-fns';
import { render } from 'datocms-structured-text-to-html-string';
import { useRouter } from 'next/router';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components */
import SimpleButton from '@components/Buttons/SimpleButton';
import StructuredTextContent from '@components/UI/StructuredTextContent';
import LazyLoadImageComponent from '@app-ihs/components/UI/LazyLoadImageComponent';

/**
 * Returns the Top Banner Event .
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Content from API
 * @param {string} region - Region of page
 * @param {string} language - Lang of page
 * @returns {ReactElement} LapOfMasterTopBanner component
 */

const LapOfMasterTopBanner = ({
    sectionContent,
    region,
    language,
    pageName,
    FYDdate,
    pageConfig,
    csrData,
    secImage,
    sectionId

}) => {
    const pName = pageConfig?.pageName;
    const [disableButton, setDisableButton] = useState(false);
    const [newButton, setNewButton] = useState(null);
    const [formattedDate, setFormattedDate] = useState('');
    const isMobile = useMediaQuery({ maxWidth: 960 });
    const styles = {
        default: 'polygon(0 0, 100% 0, 100% 100%, 0 85%)',
        'without-bottom-angle': '',
        '': 'polygon(0 0, 100% 0, 100% 100%, 0 85%)',
    };
    const router = useRouter();
    let otpBanner = sectionId === 'otp-banner'
    let isEng = language === 'en'

    useEffect(() => {
        // Check if programData is defined and has the active 'eventPgmId' property
        if (csrData && csrData?.[0]?.eventPgmId != null) {
            const date = new Date(csrData[0]?.date + 'T10:16:29.060Z');
            const newFormattedDate = format(date, 'MMM do yyyy');
            setFormattedDate(newFormattedDate);
            const disableButton = csrData[0]?.eventPgmId === undefined;
            setDisableButton(disableButton);
        }

        if (pName === 'freeyogaday' && !csrData?.length > 0) {
            setDisableButton(true);
        }

        const heading = document.getElementById('titleHeading');
        if (heading && isEng) {
            const text = heading.textContent.trim();
            const words = text.split(' ');
            if (words.length >= 2) {
                const firstTwo = words.slice(0, 2).join(' ');
                const rest = words.slice(2).join(' ');
                heading.innerHTML = `
                <span style="font-size: ${isMobile ? '42px' : '80px'}; parag">
                    ${firstTwo}
                </span> ${rest}
                `;
            }
        }
    }, [csrData, isMobile]);

    useEffect(() => {
        // console.log('useEffect', sectionContent, router.asPath.indexOf('21-day-challenge-idy'), router.query.referrer_id, region)
        if (region !== 'in' && router.asPath.indexOf('21-day-challenge-idy') > -1 && router.query.referrer_id) {
            sectionContent.button[0].linkUrl = '#challenge-form';
            setNewButton(sectionContent.button);
            // console.log('sectionContent11', sectionContent);
        }
        // console.log('useEffect2', sectionContent)
    }, [router.query, router.asPath]);

    const clickH = (values) => {
        // console.log('clickH', router.asPath);
        if (router.asPath.indexOf('21-day-challenge-idy') > -1) {
            window.dataLayer.push({
                event: region === 'in' ? 'IDY_Accept_Challenge' : 'IDY_Download_the_app',
                IDY_LP_Location: 'Top_level_CTA',
            });
        }
    };

    return (
        <Box
            display={'grid'}
            // mb={'70px'}
            pos={'relative'}
            h={{ base: '100%', md: 'auto' }}
            // maxH={620}
            // minH={{ base: 550 }}
            bgColor={{
                base: pageName === 'IDYPage' ? '#fffcf5' : '#f8f5f0',
                lg: 'transparent',
            }}
        >
            <Box height={'auto'} w={'100%'}>
                <Box
                    alignItems={'center'}
                    display={'flex'}
                    h={{
                        base: pName === 'chyp' ? '92vw' : '105.9375vw',
                        md: 'auto',
                    }}
                    minH={{
                        base: '105.9375vw',
                        sm: '500px',
                    }}
                    backgroundRepeat="no-repeat"
                    bgColor={'#140F15'}
                    //   bgColor={{
                    //     base: pageName === 'IDYPage' ? '#fffcf5' : '#f8f5f0',
                    //     sm: 'transparent',
                    //     lg: 'transparent'
                    //   }}
                    backgroundSize="cover"
                    backgroundPosition={{
                        base: '45%',
                        sm: '45%',
                        md: pName === 'chyp' ? 'top' : pageName === 'IDYPage' ? '100%' : '',
                        lg: pName === 'chyp' ? 'top' : 'top center',
                        xl: '0',
                    }}
                    backgroundImage={{
                        md: sectionContent?.desktopImage?.url,
                        base: sectionContent?.mobileImage?.url ||
                            sectionContent?.desktopImage?.url,
                        // ? show right of image in desktopImage when there is no mobileImage
                    }}
                    mb={{ base: '0', xl: '0' }}
                    pt={isEng ? {xl: '0px', "2xl": '4rem' } : {xl: '3rem', "2xl": '9rem' }}
                    clipPath={styles[sectionContent.style]}
                    pb={!isEng ? {xl:'0px', "2xl": '1rem'} : undefined}
                >
                    {!isMobile && (
                        <Flex
                            flexDirection="column"
                            verticalAlign={'center'}
                            p={{ base: pageName === 'chyp' ? '0px 15px 20px 15px' : '7px', md: pName === 'hytt' ? "0 0 0 103px" : (isEng ? '5% 0 0 0%' : undefined) }}
                            w={{ base: '100%', sm: '100%', md: '100%' }}
                            maxW={{
                                base: 'auto',
                                md: '100%',
                            }}
                            fontSize={{
                                sm: '44px',
                                base: '30px',
                            }}
                            color={'#28231e'}
                            fontFamily="FedraSansStd-A-medium"
                            display={{
                                base: 'none',
                                sm: 'none',
                                lg: 'flex',
                            }}
                            justifyContent={'center'}
                            alignItems={'center'}
                        >
                            {/* {pageName === 'IDYPage' && (
                <Box fontSize={{ md: '18px' }} fontWeight="400">
                  UNESCO PRESENTS
                </Box>
              )} */}
                            {render(sectionContent?.description) &&
                                render(sectionContent?.description) !== '<p></p>' && (
                                    <Box
                                        id="event-description"
                                        fontSize={isEng ? {
                                            base: '16px',
                                            md: '48px'} : {
                                            base: '16px',
                                            md: '40px'
                                        }}
                                        lineHeight={isEng ? { base: '24px', lg: '24px', "2xl": '56%' } : { base: '24px', md: '56%' }}
                                        fontFamily={isEng ? "FedraSerifAStdBook" : "MuktaMalar"}
                                        color={'#FFFDFD'}
                                        fontWeight={isEng ? 350 : undefined}
                                    // w={pName === 'chyp' ? '514px' : '382px'}
                                    // mt={otpBanner ? {lg:"10px"} : undefined}
                                    >
                                        {StructuredTextContent(sectionContent.description)}
                                    </Box>
                                )}
                            <Box
                                id={'titleHeading'}
                                as="h1"
                                lineHeight={isEng ? { lg: '60px', "2xl": '70px' } : { lg: "65px", "2xl": '110px' }}
                                fontWeight={'350'}
                                fontSize={isEng ? { base: '32px', md: '44px', lg: '48px' } : 
                                { base: '32px', md: '44px', lg: '55px', '2xl': '96px' }}
                                color={'#C7BFAD'}
                                fontFamily={isEng ? "FedraSerifAStdBook" : "MuktaMalar"}
                                width={{ lg: isEng ? '50rem' :  '750px' }}
                                textAlign={'center'}
                                py={isEng ? {lg: '2.5rem', "2xl": '3.5rem'} : '2rem'}                               
                            >
                                {sectionContent?.title}
                            </Box>
                            
                            <Box mt={'-1.5rem'} mb={isEng ? {lg: '1rem', '2xl': '2rem' }: '2rem'}
                                borderTop={'1.11px solid #A98C5E'} width={{ lg: '342px' }} />

                            {render(sectionContent.titleSubtext) &&
                                render(sectionContent?.titleSubtext) !== '<p></p>' && (
                                    <Box
                                        fontSize={{
                                            base: '16px',
                                            md: isEng ? '24px' : '40px',
                                        }}
                                        fontFamily={isEng ? "FedraSansStd-book" : "MuktaMalar"}
                                        color="#FFFFFF"
                                        letterSpacing="1px"
                                        lineHeight={{ lg: '26px' }}
                                        mb={isEng ? {lg: '1.5rem', '2xl': '3rem'} : '2rem'}
                                        fontWeight={isEng ? 400 : undefined}
                                    >
                                        {StructuredTextContent(sectionContent.titleSubtext)}
                                    </Box>
                                )}
                            <Flex flexDir={'row'} width={{ lg: '710px' }} position={'relative'}>
                                <Box
                                pos={'absolute'} left={isEng ? '45%' : '51%'} top={!isEng ? '0.8rem' : undefined}
                                height={{ lg: isEng ? '98%' : '114px' }} width={'1px'} borderLeft={'0.5px solid #EAE3D4'}></Box>
                                <Box w={'50%'} ml={isEng ? '2rem' : '5rem'}>
                                    {render(sectionContent?.date) &&
                                        render(sectionContent?.date) !== '<p></p>' && (
                                            <Box
                                                fontSize={{
                                                    base: '16px',
                                                    md: isEng ? '20px' : '24px',
                                                }}
                                                fontFamily={isEng ? "FedraSansStd-book" : "MuktaMalar"}
                                                fontWeight={isEng ? '450' : '500'}
                                                mt={2}
                                                color={'#FFFFFF'}
                                                lineHeight={isEng ? '140%' : undefined}
                                            >
                                                {StructuredTextContent(sectionContent.date)}
                                            </Box>
                                        )}
                                    {sectionContent?.button?.length > 0 && (
                                        <Box ml={isEng ? '0rem' : '2.6rem'}>
                                            <SimpleButton
                                                style={sectionContent.button[0]}
                                                region={region}
                                                lang={language}
                                                mb="5px"
                                                pageName={pageName}
                                                pageConfig={pageConfig}
                                                disableButton={disableButton}
                                                clickHandler={() => {
                                                    clickH();
                                                }}
                                                fontSize={isEng ? '16px' : '18px'}
                                                fontFamily={isEng ? "FedraSansStd-Medium" : "MuktaMalar"}
                                                width={!isEng ? '196px' : undefined}
                                            />
                                        </Box>
                                    )}
                                </Box>
                                <Box w={'50%'}>
                                    {render(sectionContent?.closedMessage) &&
                                        render(sectionContent?.closedMessage) !== '' && (
                                            <Box
                                                fontSize={{ base: '16px', md: isEng ? '22px' : '18px' }}
                                                fontFamily={isEng ? "FedraSansStd-book" : "MuktaMalar"}
                                                color={'#FFFFFF'}
                                                fontWeight={isEng ? 400 : undefined}
                                                lineHeight={isEng ? '30px' : undefined}
                                                mt={!isEng ? '0.8rem' : undefined}
                                            >
                                                {StructuredTextContent(sectionContent.closedMessage)}
                                            </Box>
                                        )}

                                </Box>
                            </Flex>


                            {render(sectionContent?.bottomText) &&
                                render(sectionContent?.bottomText) !== '<p></p>' && (
                                    <Box
                                        id="donate-button"
                                        fontSize={{
                                            base: '16px',
                                            md: '16px'
                                        }}
                                        fontFamily={isEng ? "FedraSansStd-book" : "MuktaMalar"}
                                        mt={isEng ? {lg: '1rem', '2xl': "2rem"} : '10px'}
                                        width={pName === 'chyp' ? '600px' : 'auto'}
                                        lineHeight="16px"
                                        color={'#F6CD92'}
                                        mb={isEng ? '2rem' : '1rem'}
                                        fontWeight={isEng ? 450 : undefined}
                                    
                                    >
                                        {StructuredTextContent(sectionContent.bottomText)}
                                    </Box>
                                )}

                        </Flex>
                    )}
                </Box>

                {isMobile && (
                    <Flex
                        display={{
                            base: 'flex',
                            sm: 'flex',
                            md: 'flex',
                            lg: 'none',
                            xl: 'none',
                        }}
                        flexDirection="column"
                        verticalAlign={'center'}
                        w={{base: '100%', sm: '100%', md: '100%', lg: '50%' }}
                        p={{ base: pName == "hytt" ? "30px 26px" : '20px 15px', sm: pName == "hytt" ? "30px 40px" : '20px 15px', md: '30px' }}
                        bg={'linear-gradient(180deg, rgba(3, 2, 2, 0) 21.65%, #030202 39%)'}
                        pt={isEng ? '10rem' : '0rem'}
                        mt={isEng ? '-22rem' : '-14rem'}
                        fontFamily="MuktaMalar"
                        height={pName === "hytt" && "550px"}
                        justifyContent={'center'}
                        alignItems={'center'}
                    >
                        {render(sectionContent?.description) &&
                            render(sectionContent?.description) !== '<p></p>' && (
                                <Box
                                    id="event-description"
                                    fontSize={'24px'}
                                    lineHeight={isEng ? '60%' : '130%'}
                                    fontFamily={isEng ? "FedraSerifAStdBook" : "MuktaMalar"}
                                    color={'#FFFDFD'}
                                    fontWeight={isEng ? 350 : undefined}
                                >
                                    {StructuredTextContent(sectionContent.description)}
                                </Box>
                            )}
                        <Box
                            id={'titleHeading'}
                            as="h1"
                            // lineHeight={'110px'}
                            fontWeight={'350'}
                            fontSize={isEng ? '24px' : '34px'}
                            color={'#C7BFAD'}
                            fontFamily={isEng ? "FedraSerifStd-book" : "MuktaMalar"}
                            textAlign={'center'}
                            lineHeight={isEng ? '160%' : '150%'}
                            my={isEng ? '0rem' : '0.5rem'}
                            mt={isEng ? '1rem' : undefined}
                            width={isEng ? '13rem' : undefined}
                        >
                            {sectionContent?.title}
                        </Box>
                        <Box
                            borderBottom={'1.11px solid #A98C5E'} width={'239px'} my={'0.5rem'}/>

                        {render(sectionContent.titleSubtext) &&
                            render(sectionContent?.titleSubtext) !== '<p></p>' && (
                                <Box
                                    fontSize={'16px'}
                                    fontFamily={isEng ? "FedraSansStd-book" : "MuktaMalar"}
                                    color="#FFFFFF"
                                    fontWeight={400}
                                    letterSpacing="1px"
                                    lineHeight={'24px'}
                                    mt={'1rem'}
                                    textAlign={isEng ? 'center' : undefined}
                                >
                                    {StructuredTextContent(sectionContent.titleSubtext)}
                                </Box>
                            )}

                        {render(sectionContent?.date) &&
                            render(sectionContent?.date) !== '<p></p>' && (
                                <Box
                                    fontSize={'20px'}
                                    fontFamily={isEng ? "FedraSansStd-book" : "MuktaMalar"}
                                    fontWeight={'500'}
                                    mt={'1rem'}
                                    lineHeight={'130%'}
                                    color={'#FFFFFF'}
                                    textAlign={isEng ? 'center' : undefined}
                                >
                                    {StructuredTextContent(sectionContent.date)}
                                </Box>
                            )}

                        {render(sectionContent?.closedMessage) &&
                            render(sectionContent?.closedMessage) !== '' && (
                                <Box
                                    fontSize={'14px'}
                                    fontFamily={isEng ? "FedraSansStd-book" : "MuktaMalar"}
                                    color={'#C0C0C0'}
                                    textAlign={'center'}
                                    lineHeight={'150%'}
                                    mt={'1rem'}
                                    fontWeight={isEng ? '400' : undefined}
                                >
                                    {StructuredTextContent(sectionContent.closedMessage)}
                                </Box>
                            )}

                        {sectionContent?.button?.length > 0 && (
                            <Box marginTop="1rem">
                                <SimpleButton
                                    style={sectionContent.button[0]}
                                    region={region}
                                    lang={language}
                                    mb="1rem"
                                    pageName={pageName}
                                    pageConfig={pageConfig}
                                    disableButton={disableButton}
                                    clickHandler={() => {
                                        clickH();
                                    }}
                                    fontSize={isEng ? '16px' : '18px'}
                                    fontFamily={isEng ? "FedraSansStd-Medium" : "MuktaMalar"}
                                />
                            </Box>
                        )}

                        {render(sectionContent?.bottomText) &&
                            render(sectionContent?.bottomText) !== '<p></p>' && (
                                <Box
                                    // id="donate-button"
                                    fontSize={{
                                        base: '16px',
                                        md: '16px'
                                    }}
                                    fontFamily={isEng ? "FedraSansStd-book" : "MuktaMalar"}
                                    lineHeight={isEng ? '130%' : "150%"}
                                    color={'#F6CD92'}
                                    textAlign={'center'}
                                    px={isEng ? '2rem' : '5rem'}
                                    mb={'0.5rem'}
                                    fontWeight={isEng ? 400 : undefined}
                                >
                                    {StructuredTextContent(sectionContent.bottomText)}
                                </Box>
                            )}

                    </Flex>
                )}
            </Box>
            <style global jsx>
                {`
          #event-description h2 {
            font-size: 27px;
            color: #28231e;
            font-family: 'FedraSansStd-medium';
            padding: 15px 0 0 0;
          }
          #donate-button a {
            color:#cf4520;
            text-decoration:underline;
          }
          #donate-button a:hover {
            text-decoration:none;
          }
          .closeMessage {
            color: black;
            margin-top: 5px;
            font-size: 16px;
          }
          .closeMessage a {
            color: #cf4824;
          }
          .hytt-closemessage {
            color:#90816E;
            margin-top: 5px;
            font-size: 16px;
          }

          @media (max-width: 767px) {
            #event-description h2 {
              font-size: 20px;
          }        
        `}
            </style>
        </Box>
    );
};

export default LapOfMasterTopBanner;
